import React, { useState } from "react";
import PermissionsGroupService from "../../../services/v2/management/management-service";

const PermissionsDelete = ({ group, close, refresh }) => {
  const [error, setError] = useState(null); // Estado para manejar errores
  const [users, setUsers] = useState([]); // Estado para usuarios asociados al grupo

  const handleDelete = async () => {
    try {
      await PermissionsGroupService.deleteById(group._id);
      refresh();
      close();
    } catch (err) {
      console.error("Failed to delete group:", err);
      setError(
        err.response?.data?.message ||
          "Failed to delete group. Please try again."
      );

      // Verificar si la respuesta incluye usuarios asociados
      if (err.response?.data?.users) {
        setUsers(err.response.data.users);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-lg flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Delete Group
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Are you sure you want to delete <strong>{group?.name}</strong>?
        </p>
        {error && (
          <div className="mt-4 bg-red-100 text-red-600 px-4 py-2 rounded-md text-sm font-medium">
            {error}
          </div>
        )}
        {users.length > 0 && (
          <div className="mt-4 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-md text-sm font-medium">
            <p className="font-semibold">Users associated with this group:</p>
            <ul className="list-disc pl-5">
              {users.map((user, index) => (
                <li key={index}>
                  {user.name} ({user.email})
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={close}
            className="bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 py-2 px-4 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default PermissionsDelete;
